interface Vertical {
  [vertical: string]: string;
}

const verticals: Vertical = {
  women: "women's",
  home: 'home',
  kids: 'kids',
  beauty: 'beauty'
};

export function formatVertical(vertical = '', capitalize = false) {
  const result = verticals[vertical];
  if (!result) return '';
  else if (capitalize) return result.charAt(0).toUpperCase() + result.slice(1);
  else return result;
}
